module.exports = __webpack_public_path__ + "public/images/generated-photography.9e1be85f50adb0f3328704aaadfec18f.jpg";